import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const Academy: React.FC = () => {
  return (
    <Container className="py-5">
      <div className="text-center mb-5">
        <h1 className="display-4 fw-bold text-navy">Academy Program</h1>
        <p className="lead text-muted">For players born in 2016 & 2017 (U9-U10)</p>
        <hr className="w-25 mx-auto text-teal" style={{ opacity: 1, height: '3px' }} />
      </div>

      <Row className="mb-5 align-items-center">
        <Col md={6}>
          <h2 className="text-teal fw-bold">The Bridge to Select</h2>
          <p>
            The 515 Soccer Academy program is designed to bridge the gap between recreational soccer and competitive "Select" soccer. 
            We focus on individual ball mastery, understanding the game, and most importantly, falling in love with the sport.
          </p>
          <p>
            Our licensed coaches provide a fun, structured environment where mistakes are seen as learning opportunities.
          </p>
        </Col>
        <Col md={6}>
            <div className="bg-light p-4 rounded shadow-sm">
                <h4 className="fw-bold mb-3">Program Details</h4>
                <ul className="list-unstyled">
                    <li className="mb-2"><strong>Ages:</strong> U9 & U10 (2016-2017 Birth Years)</li>
                    <li className="mb-2"><strong>Focus:</strong> Skill acquisition, game intelligence, fun</li>
                    <li className="mb-2"><strong>Cost:</strong> $245 / Season</li>
                    <li className="mb-2"><strong>Financial Aid:</strong> Up to 100% available</li>
                </ul>
                 <Button variant="primary" href="https://forms.gle/QqQCD3JArjrdNYVf7" target="_blank">Apply for Financial Aid</Button>
            </div>
        </Col>
      </Row>

      <Row className="g-4">
        <Col md={4}>
          <Card className="h-100 border-0 shadow-sm text-center">
            <Card.Body>
              <h3 className="h5 fw-bold text-navy">Professional Coaching</h3>
              <p className="small text-muted">Licensed coaches (D-license or better) who prioritize development over winning.</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="h-100 border-0 shadow-sm text-center">
            <Card.Body>
              <h3 className="h5 fw-bold text-navy">Local Practices</h3>
              <p className="small text-muted">Convenient locations in Altoona (Willowbrook Elementary) and Pleasant Hill.</p>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card className="h-100 border-0 shadow-sm text-center">
            <Card.Body>
              <h3 className="h5 fw-bold text-navy">No Tryouts</h3>
              <p className="small text-muted">We don't cut players. If you want to learn and work hard, you have a spot.</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <div className="mt-5 text-center">
        <h3 className="fw-bold mb-3">Join the Academy</h3>
        <p>Ready to take the next step? Register online or contact us for more info.</p>
        <div className="d-flex justify-content-center gap-3">
             <Button href="/registration" size="lg" variant="primary">Register Now</Button>
             <Button href="mailto:info@515soccer.org" size="lg" variant="outline-primary">Contact Us</Button>
        </div>
      </div>
    </Container>
  );
};

export default Academy;
